import $ from 'jquery';

export default class EFOcats_settingdata {
  constructor() {
    // 自動で取り込みをする属性のリスト
    this.importAttrs = ['maxlength', 'minlength'];
    this.attrjson = {};

    this.patterns = [];
    this.pageQuery = '';
    this.questionQuery = ';';
  }

  /**
   * efocats_read.phpからJSONデータ読込み
   * @param id ID
   * @param form_id フォームID
   * @returns 読み込んだデータ
   */
  async load(id, form_id) {
    try {
      const json = await $.ajax({
        url: 'https://formcats.com/efocats/efocats_read.php',
        datatype: 'json',
        type: 'POST',
        data: {
          ID: id,
          formID: form_id,
        },
        timeout: 5000,
      });

      if (json.error) {
        throw json.error;
      }

      return json;
    } catch (error) {
      throw 'efocats_read fail';
    }
  }

  /**
   * JSONデータを編集する
   * @param data 読み込んだデータ
   * @param formQuery 元フォームを取得するためのクエリ
   * @returns 編集したデータ
   */
  edit(data, formQuery) {
    data.form.label = [];

    // 指定したIDのフォームを取得
    const form = document.querySelector(formQuery);

    if (this.check(form)) {
      let pages = this.get_pages(form);

      for (let index = 0; index < this.patterns.length; index++) {
        const pattern = this.patterns[index];
        pages = pattern.get_pages(form, pages);
      }

      // ページ単位で処理
      pages.forEach(page => {
        const temp = {
          question: this.get_text(page),
          answer: [],
        };

        let tpl = this.get_tpl(page);

        for (let index = 0; index < this.patterns.length; index++) {
          const pattern = this.patterns[index];
          tpl = pattern.get_tpl(page, tpl);
        }

        let inputs = this.get_inputs(page);

        for (let index = 0; index < this.patterns.length; index++) {
          const pattern = this.patterns[index];
          inputs = pattern.get_inputs(page, inputs);
        }

        this.get_input_info(page, inputs, temp);

        // フリーテキスト
        this.get_free_text(page, temp);

        for (let index = 0; index < this.patterns.length; index++) {
          const pattern = this.patterns[index];
          pattern.pagedata_extend(page, temp);
        }

        // この時点で入力欄も大設問もないページは読み込みを行わない
        if (inputs.length === 0 && !this.get_text(page)) {
          return;
        }

        const lastOBj = {};
        lastOBj[tpl] = temp;

        data.form.label.push(lastOBj);
      });
    }

    return data;
  }

  /**
   * 処理を実行するかどうかを判断する
   * @param {*} form
   * @returns trueなら処理を実行する
   */
  check(form) {
    return form && form.localName === 'form';
  }

  /**
   * 入力欄をページごとに振り分ける
   * @param {*} form
   * @returns ページリスト
   */
  get_pages(form) {
    const pages = [];
    const inputs = form.querySelectorAll(this.pageQuery);

    for (let index = 0; index < inputs.length; index++) {
      pages.push(inputs[index].outerHTML);
    }

    return pages;
  }

  /**
   * 設問テキストを取得する
   * @param {*} page
   * @returns 設問テキスト
   */
  get_text(page) {
    return $(page).find(this.questionQuery).text();
  }

  /**
   * テンプレート名を取得する
   * @param {*} page
   * @returns テンプレート名
   */
  get_tpl(page) {
    // 案件ごとに子クラスで上書きをする
    return 'set-base';
  }

  /**
   * 必須かどうかを取得する
   * @param {*} page
   * @returns 必須なら1、そうでないなら0
   */
  get_required(page) {
    if ($(page).find(efocats.proj.env.requiredQuery).length >= 1) {
      return 1;
    }

    if ($(page).text().indexOf(efocats.proj.env.requiredQuery) >= 0) {
      return 1;
    }

    return 0;
  }

  /**
   * ページ内の入力欄を一通り取得する
   * @param {*} page
   * @returns 入力欄リスト
   */
  get_inputs(page) {
    const inputs = [];

    const list = $(page).find('input,select,textarea');

    for (let index = 0; index < list.length; index++) {
      inputs.push(list[index]);
    }

    return inputs;
  }

  /**
   * 入力欄の情報を取得する
   * @param {*} input
   * @param {*} temp
   */
  get_input_info(page, input, temp) {
    const nameList = [];

    for (let k = 0, l = input.length; k < l; k++) {
      if (input[k].type === 'radio' || input[k].type === 'checkbox') {
        // 既に処理したnameのものはスキップ
        if (nameList.indexOf(input[k].name) === -1) {
          nameList.push(input[k].name);

          const tempval = [];

          for (let index = 0; index < input.length; index++) {
            if (input[index].name === input[k].name) {
              const val = {};
              val[input[index].value] = input[index].parentNode.textContent;
              val[input[index].value] = val[input[index].value].replace('可', 'はい').replace('否', 'いいえ');
              tempval.push(val);
            }
          }

          const tempanswer = {
            type: input[k].type,
            name: input[k].name,
            'data-required': String(this.get_required(page)),
            value: tempval,
          };

          // 属性設定
          this.get_attr(page, input, k, tempanswer);

          temp.answer.push(tempanswer);
        }
      } else {
        const tempanswer = {
          type: this.get_type(input, k),
          name: input[k].name,
          'data-required': String(this.get_required(page)),
        };

        if (tempanswer.type === 'select') {
          tempanswer.value = [];
          const option = input[k].querySelectorAll('option');
          for (let n = 0; option.length > n; n++) {
            const tempval = {};
            tempval[option[n].value] = option[n].text;
            tempanswer.value[n] = tempval;
          }
        }

        // 属性設定
        this.get_attr(page, input, k, tempanswer);

        temp.answer.push(tempanswer);
      }
    }
  }

  /**
   * タイプを取得する
   * @param {*} inputs
   * @param {*} index
   * @returns タイプ
   */
  get_type(inputs, index) {
    return inputs[index].localName === 'select' || inputs[index].localName === 'textarea' ? inputs[index].localName : inputs[index].type;
  }

  /**
   * フリーテキストを取得する
   * @param {*} page
   * @param {*} temp
   * @returns フリーテキスト
   */
  get_free_text(page, temp) {
    // 案件ごとに子クラスで上書きをする
    return '';
  }

  /**
   * 属性を取得する
   * @param {*} page
   * @param {*} inputs
   * @param {*} index
   * @param {*} tempanswer
   */
  get_attr(page, inputs, index, tempanswer) {
    // 元の入力欄に設定されている属性を取得する
    const attrs = inputs[index].attributes;

    for (let attrIndex = 0; attrIndex < attrs.length; attrIndex++) {
      const attr = attrs[attrIndex];

      if (this.importAttrs.includes(attr.name)) {
        tempanswer[attr.name] = attr.value;
      }
    }

    // type=telはmaxlengthを11桁に制限する
    if ($(inputs[index]).attr('type') === 'tel') {
      tempanswer.maxlength = 11;
    }

    // 案件にattr.jsonがある場合はその内容を読み込んで反映する
    Object.keys(this.attrjson).forEach(selector => {
      if ($(inputs[index]).is(selector)) {
        Object.keys(this.attrjson[selector]).forEach(element => {
          tempanswer[element] = this.attrjson[selector][element];
        });
      }
    });

    for (let patterIndex = 0; patterIndex < this.patterns.length; patterIndex++) {
      const pattern = this.patterns[patterIndex];
      pattern.get_attr(page, inputs, index, tempanswer);
    }
  }
}
